
import React from 'react';
import axios from 'axios';
import $ from 'jquery';

import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import paginationFactory from 'react-bootstrap-table2-paginator';
import filterFactory from 'react-bootstrap-table2-filter';
import { getSessionID, getSessionName, getCompanyID } from '../../../../../Utils/Common';
import AddShiftDefinition from './addShiftDefinitions';

class PayrollUserShiftDefinitions extends React.Component {
  constructor () {
      super();

      this.state = {
        tableData:[]
      };
  }

  componentDidMount () {
    let self = this;

    const session_Name = getSessionName();
    if (!session_Name) {
      return;
    }

    const session_ID = getSessionID();
    if (!session_ID) {
      return;
    }
  
    const company_id = getCompanyID();
    if (!company_id) {
      return;
    }

    
    axios.get('http://payroll.nikkolim.com/get_shift_definitions/shift_definitions_company/'+company_id, {
    headers: {
      'Content-Type': 'application/json',
      "Authentication": session_Name+"="+session_ID,
    }
  })
  .then((response) => {
    const data = [];
    $.each( response.data, function( i, val ) {   
        //console.log(JSON.stringify(val));
      $.each(val, function( i, val2 ){
        data.push(val2.attributes);
        self.setState({
            tableData: data
        });
        //console.log(JSON.stringify(data));
      })
      
    });
    //console.log(JSON.stringify(response.data));
  }, (error) => {
    console.log(error);
  });
  
  }

//   valueFormatter(cell, row){
//     return (
//       <div><a className="btn btn-primary" href={"employees-details/"+cell}>View Details</a></div>
//       );
//   }

  render () {
      const { tableData } = this.state;
      const textfilter = { type: 'TextFilter', delay: 1000};
      const datefilter = { type: 'DateFilter', delay: 1000};

      let datalist = [{
        dataField: 'field_definition_name',
        text: 'Name',
      }, {
        dataField: 'field_definition_company_label',
        text: 'Company'
      },{
        dataField: 'field_definition_ustart',
        text: 'Start'
      },{
        dataField: 'field_definition_work_duration',
        text: 'Work Duration'
      },{
        ataField: 'field_definition_ucutoff',
        text: 'Cut Off'
      },{
        ataField: 'field_definition_grace_period',
        text: 'Grace Period'
      },{
        ataField: 'field_definition_uend',
        text: 'End'
      },{
        ataField: 'field_definition_active',
        text: 'Active'
      },{
        dataField: 'entity_id',
        text: 'ID'
      }];
      
      return (
        
      <div>
        <h1 class="h3 mb-0 text-gray-800">Shift Definitions</h1>
        <div className="add-button"><AddShiftDefinition></AddShiftDefinition></div>
        <BootstrapTable responsive wrapperClasses='table-responsive' bootstrap4 version='4' keyField='entity_id' filter={ filterFactory() } columns={ datalist } data={ tableData } pagination={ paginationFactory() } search>
          <TableHeaderColumn dataSort dataField='field_definition_name' filter={textfilter}>Name</TableHeaderColumn>
          <TableHeaderColumn dataSort  dataField='field_definition_company_label' filter={textfilter}>Company</TableHeaderColumn>
          <TableHeaderColumn dataSort  dataField='field_definition_ustart' filter={textfilter}>Start</TableHeaderColumn>
          <TableHeaderColumn dataField='field_definition_work_duration'filter={textfilter} >Work Duration</TableHeaderColumn>
          <TableHeaderColumn dataField='field_definition_ucutoff' filter={textfilter}>Cut Off</TableHeaderColumn>
          <TableHeaderColumn dataField='field_definition_grace_period' filter={textfilter}>Grace Period</TableHeaderColumn>
          <TableHeaderColumn dataField='field_definition_uend' filter={textfilter}>End</TableHeaderColumn>
          <TableHeaderColumn dataField='field_definition_active' filter={textfilter}>Active</TableHeaderColumn>
        </BootstrapTable>
      </div>  
      );
  }
};



export default PayrollUserShiftDefinitions;

